const host = "";
// const host = "http://127.0.0.1:8000";
// const host = "http://91.210.191.82";

export default {
	host,
	apiHost : host + "/api/v1",
	maxFileSize: 16384000,

	options: {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		timezone: 'UTC',
		hour: 'numeric',
		minute: 'numeric'
	  }
}



// WEBPACK FOOTER //
// ./src/config.js